/* Giesse Vintage — comportamento dei video prodotto.

   1. Nella galleria della scheda prodotto il video parte da solo, muto.
      Dawn di suo mostra solo l'anteprima e aspetta un clic.
   2. Nella griglia dei prodotti il video parte al passaggio del mouse
      e si ferma quando il mouse esce.

   Sempre muto e playsinline: è l'unico modo in cui i browser permettono
   la riproduzione senza un gesto dell'utente. */
(function () {
  if (window.__gsVideo) return;
  window.__gsVideo = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prep(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.loop = true;
  }

  function safePlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  /* --- 1. Galleria scheda prodotto -------------------------------------- */
  function autoplayGallery() {
    if (reduce.matches) return;

    document.querySelectorAll('.product__media-item deferred-media').forEach(function (dm) {
      /* deferred-media tiene il video dentro un <template> finché non si
         clicca il poster: lo forziamo ad aprirsi subito. */
      if (dm.dataset.gsOpened) return;
      dm.dataset.gsOpened = '1';
      if (typeof dm.loadContent === 'function') {
        dm.loadContent(false);
      }
    });

    document.querySelectorAll('.product__media-item video').forEach(function (video) {
      if (video.dataset.gsAuto) return;
      video.dataset.gsAuto = '1';
      prep(video);
      video.setAttribute('autoplay', '');
      video.removeAttribute('controls');
      video.controls = true;
      safePlay(video);
    });
  }

  /* --- 2. Video al passaggio del mouse nella griglia --------------------- */
  function bindCards() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.gsHover) return;
      var video = card.querySelector('video');
      if (!video) return;
      card.dataset.gsHover = '1';
      prep(video);
      video.removeAttribute('controls');

      card.addEventListener('mouseenter', function () {
        if (reduce.matches) return;
        safePlay(video);
      });
      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  function run() {
    autoplayGallery();
    bindCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* la galleria si ricostruisce al cambio variante e nel personalizzatore */
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 500);
  setTimeout(run, 1500);
})();
